export default "__VITE_ASSET__DJWNjz03__"